import { REWARDS_BULK_UPLOAD_FORM_MODAL_MODULE_ID, } from 'root/src/shared/descriptions/modules/moduleIds';
export const rewardsBulkUploadModal = {
    [REWARDS_BULK_UPLOAD_FORM_MODAL_MODULE_ID]: {
        moduleType: 'modal',
    },
};
